import { render, staticRenderFns } from "./CoursesWrapperView.vue?vue&type=template&id=46f6f4f7&scoped=true"
import script from "./CoursesWrapperView.vue?vue&type=script&lang=js"
export * from "./CoursesWrapperView.vue?vue&type=script&lang=js"
import style0 from "./CoursesWrapperView.vue?vue&type=style&index=0&id=46f6f4f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6f4f7",
  null
  
)

export default component.exports